import { CurrencyPipe, DatePipe, DecimalPipe, PercentPipe } from '@angular/common';
import { ChangeDetectorRef, DEFAULT_CURRENCY_CODE, Inject, LOCALE_ID, Pipe } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppSettingsDto } from '../../services/api.services';
import { SettingsDrivenPipeOverride } from './settings-driven-pipe-override';

@Pipe({
  name: 'currency',
  pure: false,
  standalone: false
})
export class SettingsDrivenCurrencyPipe extends SettingsDrivenPipeOverride<CurrencyPipe> {
  protected getPipe() {
    return new CurrencyPipe(this.pipeLocale, this.defaultCurrencyCode);
  }

  protected onTransform(pipe: CurrencyPipe, settings: AppSettingsDto, value: any, currencyCode?: string, display?: string, digitsInfo?: string, locale?: string) {
    let locale_ = locale ?? settings.locale ?? this.pipeLocale;
    let currencyCode_ = currencyCode ?? settings.currency ?? this.defaultCurrencyCode;

    return pipe.transform(value, currencyCode_, display, digitsInfo, locale_);
  }
}
